module.exports = __webpack_public_path__ + "static/media/close.396da3d5.svg";